<template>
  <div id="tac-admin-security-session" class="tac-admin-security-session tac-admin-security-session--record">
    <div class="page-header tac-admin-security-session__header">
      <h1 class="page-header-title">
        <span class="fa fa-fw fa-list"></span>
        Session
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner">
          <div class="form-group form-group-sm tac-admin-security-session__actions">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button class="btn btn-default btn-sm" type="button" :disabled="loading" @click="goBackToList" title="Back to List Page"><i class="fa fa-fw fa-arrow-left"></i> Back</button>
              </div>
              <div class="btn-group">
                <button class="btn btn-default btn-sm" :disabled="loading" type="button" @click="reload" title="Reload Content"><i class="fa fa-fw fa-refresh"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="session && session.key">
      <div class="col-lg-11 col-md-10 col-sm-10 col-xs-9">
        <div class="form-horizontal">
          <div class="form-group">
            <label class="col-lg-1 control-label">Key</label>
            <div class="col-lg-5">
              {{ session.key }}
            </div>
          </div>
          <div class="form-group">
            <label class="col-lg-1 control-label">Expire</label>
            <div class="col-lg-10">
              {{ session.expire }} [ {{ formattedExpiration(session.expire) }} ]
            </div>
          </div>
          <div class="form-group">
            <label class="col-lg-1 control-label">Decoded</label>
            <div class="col-lg-11">
              <pre>{{ session.decoded }}</pre>
            </div>
          </div>
          <div class="form-group">
            <label class="col-lg-1 control-label">Value</label>
            <div class="col-lg-11">
              {{ session.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div><!-- #tac-admin-security-session -->
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'

  export default {
    data() {
      return {
        key: null,
        session: null,
        loading: false
      }
    },
    created() {
      this.key = this.$route.params.key

      this.load()
    },
    methods: {
      async load() {
        await this.fetchNote()
      },
      async reload() {
        await this.fetchNote()
      },
      async fetchNote() {
        this.loading = true

        let result = null
        try {
          result = await this.axios.get(`admin/session/view/${this.key}`)
        } catch (e) {
          this.loading = false
          throw e
        }

        this.session = _.chain(result)
          .get('data.session')
          .value()

        this.loading = false
      },
      goBackToList() {
        this.$router.push({
          name   : 'admin-session/list',
          params : _.assign({}, this.$route.params),
          query  : _.assign({}, this.$route.query)
        })
      },
      formattedExpiration(time) {
        return moment(time, 'X').format('MM/DD/YY hh:mm:ss a')
      }
    }
  }
</script>
